import { Inject, Injectable } from "@angular/core";
import {  AdminMediaBanner, MediaBanner, SubmitResponse } from "../../../models";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../http.service";
import { MediaBannerData, MediaBannerTranslation } from "../../../models/admin/media.model";


@Injectable({
    providedIn: 'root'
})
export class MediaBannerService extends HttpService<any, MediaBannerData | MediaBannerTranslation | AdminMediaBanner> {
    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'media/banners');
    }

    getAllMediaBanners(page = 1, limit?: number): Observable<MediaBannerData> {
        return this.getAllPaged('admin/list', page, '', limit) as Observable<MediaBannerData>;
    }


    deleteBanner(bannerId: string): Observable<SubmitResponse> {
        return this.delete(bannerId).pipe(catchError((error) => of(error)));
    }
    createMediaBanner(mediaInput: any): Observable<MediaBannerTranslation> {
        return this.create(mediaInput).pipe(catchError((error) => of(error)));
    }
    updateMediaBanner(id: string, mediaInput: any): Observable<MediaBannerTranslation> {
        return this.update(mediaInput, id).pipe(catchError((error) => of(error)));
    }

    updateBannerOrder(payload: any): Observable<SubmitResponse> {
        return this.update(payload, 'positions/align').pipe(catchError((error) => of(error)));
    }
    getMediaBannerById(id: number): Observable<MediaBannerTranslation> {
        return this.getById(id) as Observable<MediaBannerTranslation>;
    }





}
